export const FORM_FIELDS_NAME = {
  ADDRESS: "address",
  AFTERHOURFEE: "afterHourFee",
  AFTERHOURFEESTATUS: "afterHourFeeStatus",
  AFTERHOURDROPOFF: "afterHourDropoff",
  AFTERHOURDROPOFFFEE: "afterHourDropoffFee",
  AIRPORTCHARGESTATUS: "airportChargeStatus",
  AIRPORTCODE: "airportCode",
  AIRPORTCONCESSIONFEERATE: "airportConcessionFeeRate",
  AIRPORTFACILITYCHARGE: "airportFacilityCharge",
  AIRPORTFACILITYCHARGEMAXDAYS: "airportFacilityChargeMaxDays",
  ANYAIRPORTLOCATION: "anyAirportLocation",
  CATEGORYID: "categoryId",
  CITY: "city",
  CONCESSIONFEETYPE: "concessionFeeType",
  CONTACT: "contact",
  COUNTRY: "country",
  CRDBY: "crdBy",
  CRTTIME: "crtTime",
  CURRENCYCODE: "currencyCode",
  ENERGYRECOVERYFEE: "energyRecoveryFee",
  FRIAFTERHOUREND: "friAfterHourEnd",
  FRIENDHOUR: "friEndHour",
  FRISTARTHOUR: "friStartHour",
  GMAPLINK: "gmapLink",
  ID: "id",
  LATITUDE: "latitude",
  LOCATIONEXTRAHOURREQUESTS: [
    {
      AFTERENDHOUR: "afterEndHour",
      ENDDATE: "endDate",
      ENDHOUR: "endHour",
      ID: "id",
      LOCATIONID: "locationId",
      STARTDATE: "startDate",
      STARTHOUR: "startHour",
      STATUS: "status"
    }
  ],
  LOCATIONNAME: "locationName",
  LOCATIONPOLICY: "locationPolicy",
  LONGITUDE: "longitude",
  MAINTENANCEFEE: "maintenanceFee",
  MODBY: "modBy",
  MODTIME: "modTime",
  MONAFTERHOUREND: "monAfterHourEnd",
  MONENDHOUR: "monEndHour",
  MONSTARTHOUR: "monStartHour",
  PIN: "pin",
  PREFIXID: "prefixId",
  PROVINCE: "province",
  RESPREFIX: "resPrefix",
  ROADSIDESERVICE: "roadSideService",
  SATAFTERHOUREND: "satAfterHourEnd",
  SATENDHOUR: "satEndHour",
  SATSTARTHOUR: "satStartHour",
  SHUTTLEHOURS: "shuttleHours",
  STATUS: "status",
  SUNAFTERHOUREND: "sunAfterHourEnd",
  SUNENDHOUR: "sunEndHour",
  SUNSTARTHOUR: "sunStartHour",
  MONAFTERHOURDROPOFF24H: "monAfterHourDropoff24h",
  TUEAFTERHOURDROPOFF24H: "tueAfterHourDropoff24h",
  WEDAFTERHOURDROPOFF24H: "wedAfterHourDropoff24h",
  THUAFTERHOURDROPOFF24H: "thuAfterHourDropoff24h",
  FRIAFTERHOURDROPOFF24H: "friAfterHourDropoff24h",
  SATAFTERHOURDROPOFF24H: "satAfterHourDropoff24h",
  SUNAFTERHOURDROPOFF24H: "sunAfterHourDropoff24h",
  MONISCLOSED: "monIsClosed",
  TUEISCLOSED: "tueIsClosed",
  WEDISCLOSED: "wedIsClosed",
  THUISCLOSED: "thuIsClosed",
  FRIISCLOSED: "friIsClosed",
  SATISCLOSED: "satIsClosed",
  SUNISCLOSED: "sunIsClosed",
  LEADTIMEBEFOREPICKUP: "leadTimeBeforePickup",
  TAX: "tax",
  TAXPERCENT: "taxPercent",
  THUAFTERHOUREND: "thuAfterHourEnd",
  THUENDHOUR: "thuEndHour",
  THUSTARTHOUR: "thuStartHour",
  TUEAFTERHOUREND: "tueAfterHourEnd",
  TUEENDHOUR: "tueEndHour",
  TUESTARTHOUR: "tueStartHour",
  UNDERAGERATE: "underageRate",
  USERID: "userId",
  USERNAME: "username",
  VEHICLELICENSEFEE: "vehicleLicenseFee",
  WEDAFTERHOUREND: "wedAfterHourEnd",
  WEDENDHOUR: "wedEndHour",
  WEDSTARTHOUR: "wedStartHour",
  WEEKENDHOUREND: "weekEndHourEnd",
  WEEKENDHOURSTART: "weekEndHourStart",
  WEEKHOUREND: "weekHourEnd",
  WEEKHOURSTART: "weekHourStart",
  WORKINGHOURSTARTEND: "workingHourStartEnd"
};


const FORM_FIELDS_DATA =[
 ,{
    name:"locationPolicy",
     "rule": {
        "required": true
      },
    label:"Location Policy"
  }
]
export const basicDetail =
[
  {
    name:"locationName",
     "rule": {
        "required": true
      },
    label:"Location Name"
  },{
    name:"address",
     "rule": {
        "required": true
      },
    label:"Address"
  },{
    name:"city",
     "rule": {
        "required": false
      },
    label:"City"
  },{
    name:"province",
     "rule": {
        "required": false
      },
    label:"Province"
  },{
    name:"country",
     "rule": {
        "required": false
      },
    label:"Country"
  },{
    name:"pin",
     "rule": {
        "required": true
      },
    label:"PIN"
  },{
    name:"contact",
     "rule": {
        "required": true
      },
    label:"Contact Number"
  },{
    name:"gmapLink",
     "rule": {
        "required": false
      },
    label:"GMap Link"
  },{
    name:"airportCode",
     "rule": {
        "required": false
      },
    label:"Airport Code"
  },{
    name:"currencyCode",
     "rule": {
        "required": true
      },
    label:"Currency Code"
  },{
    name:"prefixId",
     "rule": {
        "required": true
      },
    label:"Reservation ID Prefix"
  },{
    name:"latitude",
     "rule": {
        "required": false
      },
    label:"Latitude"
  },{
    name:"longitude",
     "rule": {
        "required": false
      },
    label:"Longitude"
  },{
    name:"anyAirportLocation",
     "rule": {
        "required": true
      },
    label:"An Airport Location"
  },{
    name:"status",
     "rule": {
        "required": true
      },
    label:"Status"
  },{
    name:"weekHourStart",
     "rule": {
        "required": false
      },
    label:"Weekday Working Hour Start"
  },{
    name:"weekHourEnd",
     "rule": {
        "required": false
      },
    label:"Weekday Working Hour End"
  },{
    name:"weekEndHourStart",
     "rule": {
        "required": false
      },
    label:"Weekend Working Hour Start"
  },
  {
    name:"weekEndHourEnd",
     "rule": {
        "required": false
      },
    label:"Weekend Working Hour End"
  },
  {
    name:"reservationEmailTo",
     "rule": {
        "required": true
      },
    label:"Reservation Booking Email To"
  },
  {
    name:"reservationEmailBcc",
     "rule": {
        "required": true
      },
    label:"Reservation Booking Email Bcc"
  },
  {
    name:"sofiacGDSCode",
     "rule": {
        "required": false
      },
    label:"Sofiac GDS Code"
  },
  {
    name:"reservationPageText",
     "rule": {
        "required": true
      },
    label:"Reservation Page Mileage Text"
  }
  
]
export const hoursSetting =
[
  {
    name:"monStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"monEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"monAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"tueStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"tueEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"tueAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"wedStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"wedEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"wedAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"thuStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"thuEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"thuAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"friStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"friEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"friAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"satStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"satEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"satAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"sunStartHour",
     "rule": {
        "required": true
      },
    label:"Start Hour"
  },
  {
    name:"sunEndHour",
     "rule": {
        "required": true
      },
    label:"End Hour"
  },
  {
    name:"sunAfterHourEnd",
     "rule": {
        "required": true
      },
    label:"After Hour End"
  },
  {
    name:"monAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"tueAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"wedAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"thuAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"friAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"satAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"sunAfterHourDropoff24h",
     "rule": {
        "required": false
      },
    label:"24h Dropoff",
    type:"checkbox"
  },
  {
    name:"monIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"tueIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"wedIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"thuIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"friIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"satIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"sunIsClosed",
     "rule": {
        "required": false
      },
    label:"Is Closed",
    type:"checkbox"
  },
  {
    name:"leadTimeBeforePickup",
     "rule": {
        "required": false
      },
    label:"Lead Time Before Reservation (In Minutes)",
    type:"number"
  },
]

export const locationExtraHoursSetting=[
  {
    name:"startDate",
     "rule": {
        "required": false
      },
    label:"Start Date"
  },{
    name:"endDate",
     "rule": {
        "required": false
      },
    label:"End Date"
  },{
    name:"startHour",
     "rule": {
        "required": false
      },
    label:"Start Hour"
  },{
    name:"endHour",
     "rule": {
        "required": false
      },
    label:"End Hour"
  },{
    name:"afterEndHour",
     "rule": {
        "required": false
      },
    label:"After End Hour"
  }
]
export const freesCharges =[
  {
    name:"taxPercent",
     "rule": {
        "required": true
      },
    label:"Tax %age"
  }, 
  {
    name:"afterHourFee",
    "rule": {
      "required": false
    },
    label:"After Hour Fee"
  },{
    name:"afterHourFeeStatus",
    "rule": {
      "required": true
    },
    label:"After Hour Fee Status"
  },{
    name:"afterHourDropoffFee",
    "rule": {
      "required": false
    },
    label:"After Hour Dropoff Fee"
  },{
    name:"afterHourDropoff",
    "rule": {
      "required": true
    },
    label:"After Hour Dropoff Status"
  },{
    name:"energyRecoveryFee",
     "rule": {
        "required": true
      },
    label:"Energy Recovery Fee (per day)"
  },{
    name:"maintenanceFee",
     "rule": {
        "required": true
      },
    label:"Maintenance Fee (one time)"
  },{
    name:"vehicleLicenseFee",
     "rule": {
        "required": true
      },
    label:"Vehicle License Fee (per day)"
  },
  {
    name:"roadSideService",
     "rule": {
        "required": true
      },
    label:"Road Side Service (per day)"
  },{
    name:"airportFacilityCharge",
     "rule": {
        "required": true
      },
    label:"Airport Facility Charge"
  },
  {
    name:"airportFacilityChargeMaxDays",
     "rule": {
        "required": true
      },
    label:"Airport Facility Charge Max Days"
  },
  {
    name:"concessionFeeType",
     "rule": {
        "required": true
      },
    label:"Concession Fee Type"
  },
  {
    name:"airportConcessionFeeRate",
     "rule": {
        "required": true
      },
    label:"Airport Concession Fee Rate"
  },
  {
    name:"underageRate",
     "rule": {
        "required": true
      },
    label:"Underage Rate (per day)"
  },
  {
    name:"airportChargeStatus",
     "rule": {
        "required": true
      },
    label:"Airport Charge Status"
  },
  {
    name:"surcharge",
     "rule": {
        "required": true
      },
    label:"Surcharge (per day)"
  },
    {
    name:"dailyRentalFee",
     "rule": {
        "required": true
      },
    label:"Daily Vehicle Rental Fee (per day)"
  },
]

export const hourslist =[
  {"id": "12:00AM", "name": "12:00 AM"},
  {"id": "12:30AM", "name": "12:30 AM"},
  {"id": "01:00AM", "name": "01:00 AM"},
  {"id": "01:30AM", "name": "01:30 AM"},
  {"id": "02:00AM", "name": "02:00 AM"},
  {"id": "02:30AM", "name": "02:30 AM"},
  {"id": "03:00AM", "name": "03:00 AM"},
  {"id": "03:30AM", "name": "03:30 AM"},
  {"id": "04:00AM", "name": "04:00 AM"},
  {"id": "04:30AM", "name": "04:30 AM"},
  {"id": "05:00AM", "name": "05:00 AM"},
  {"id": "05:30AM", "name": "05:30 AM"},
  {"id": "06:00AM", "name": "06:00 AM"},
  {"id": "06:30AM", "name": "06:30 AM"},
  {"id": "07:00AM", "name": "07:00 AM"},
  {"id": "07:30AM", "name": "07:30 AM"},
  {"id": "08:00AM", "name": "08:00 AM"},
  {"id": "08:30AM", "name": "08:30 AM"},
  {"id": "09:00AM", "name": "09:00 AM"},
  {"id": "09:30AM", "name": "09:30 AM"},
  {"id": "10:00AM", "name": "10:00 AM"},
  {"id": "10:30AM", "name": "10:30 AM"},
  {"id": "11:00AM", "name": "11:00 AM"},
  {"id": "11:30AM", "name": "11:30 AM"},
  {"id": "12:00PM", "name": "12:00 PM"},
  {"id": "12:30PM", "name": "12:30 PM"},
  {"id": "01:00PM", "name": "01:00 PM"},
  {"id": "01:30PM", "name": "01:30 PM"},
  {"id": "02:00PM", "name": "02:00 PM"},
  {"id": "02:30PM", "name": "02:30 PM"},
  {"id": "03:00PM", "name": "03:00 PM"},
  {"id": "03:30PM", "name": "03:30 PM"},
  {"id": "04:00PM", "name": "04:00 PM"},
  {"id": "04:30PM", "name": "04:30 PM"},
  {"id": "05:00PM", "name": "05:00 PM"},
  {"id": "05:30PM", "name": "05:30 PM"},
  {"id": "06:00PM", "name": "06:00 PM"},
  {"id": "06:30PM", "name": "06:30 PM"},
  {"id": "07:00PM", "name": "07:00 PM"},
  {"id": "07:30PM", "name": "07:30 PM"},
  {"id": "08:00PM", "name": "08:00 PM"},
  {"id": "08:00PM", "name": "08:30 PM"},
  {"id": "08:30PM", "name": "09:00 PM"},
  {"id": "09:30PM", "name": "09:30 PM"},
  {"id": "10:00PM", "name": "10:00 PM"},
  {"id": "10:30PM", "name": "10:30 PM"},
  {"id": "11:00PM", "name": "11:00 PM"},
  {"id": "11:30PM", "name": "11:30 PM"}
];
export const YesNoDrop =
[
  { id:1, name:"Yes"},
  { id:2, name:"No"}
];
export const statusDrop =
[
  { id:1, name:"Active"},
  { id:0, name:"Inactive"}
]
export const afterHourFeeStatusDrop =
[
  { id:1, name:"Enable"},
  { id:2, name:"Disable"}
]
export const airportChargeStatusDrop =
[
  { id:1, name:"Enable"},
  { id:0, name:"Disable"}
]
export const concessionFeeTypeDrop =
[
  { id:1, name:"Percentage of Base Rate"},
  { id:2, name:"One Time"}
]


export const policyBreakdownlist =[
  {
    "name": "pcHrsOperations",
    "rule": {
      "required": false
    },
    "label": "Hours of Operations"
  },
  {
    "name": "pcDriverLicense",
    "rule": {
      "required": false
    },
    "label": "Driver License"
  },
  {
    "name": "pcSecurityDeposit",
    "rule": {
      "required": false
    },
    "label": "Security Deposit"
  },
  {
    "name": "pcPaymentMethod",
    "rule": {
      "required": false
    },
    "label": "Payment Method"
  },
  {
    "name": "pcPickupDropoff",
    "rule": {
      "required": false
    },
    "label": "Pickup/Dropoff"
  },
  {
    "name": "pcPickupDirection",
    "rule": {
      "required": false
    },
    "label": "Pickup Direction"
  },
  {
    "name": "pcMileageRestriction",
    "rule": {
      "required": false
    },
    "label": "Mileage Restriction"
  },
  {
    "name": "pcFuelPolicy",
    "rule": {
      "required": false
    },
    "label": "Fuel Policy"
  },
  {
    "name": "pcOutOfProvince",
    "rule": {
      "required": false
    },
    "label": "Out of Province"
  },
  {
    "name": "pcZoomCommitment",
    "rule": {
      "required": false
    },
    "label": "Zoom Commitment"
  },
  {
    "name": "pcCancellation",
    "rule": {
      "required": false
    },
    "label": "Cancellation"
  },
  {
    "name": "pcEarlyReturns",
    "rule": {
      "required": false
    },
    "label": "Early Returns"
  },
  {
    "name": "pcRentalExtension",
    "rule": {
      "required": false
    },
    "label": "Rental Extension"
  },
  {
    "name": "pcLdwCdw",
    "rule": {
      "required": false
    },
    "label": "LDW/CDW"
  },
  {
    "name": "pcNonSpecial",
    "rule": {
      "required": false
    },
    "label": "Non-Special"
  },
  {
    "name": "pcSpecialLdw",
    "rule": {
      "required": false
    },
    "label": "Special LDW"
  },
  {
    "name": "pcOtherServices",
    "rule": {
      "required": false
    },
    "label": "Other Services"
  },
  {
    "name": "pcAgeRequirement",
    "rule": {
      "required": false
    },
    "label": "Age Requirement"
  },
  {
    "name": "pcAdditionalDriver",
    "rule": {
      "required": false
    },
    "label": "Additional Driver"
  },
  {
    "name": "pcDrivingArea",
    "rule": {
      "required": false
    },
    "label": "Driving Area"
  },
  {
    "name": "pcMovingTruck",
    "rule": {
      "required": false
    },
    "label": "Moving Truck"
  },

  {
    "name": "pcAddress",
    "rule": {
      "required": false
    },
    "label": "Address"
  },
  {
    "name": "pcDisclaimer",
    "rule": {
      "required": false
    },
    "label": "Disclaimer"
  },
  {
    "name": "pcStandardTerms",
    "rule": {
      "required": false
    },
    "label": "Standard Terms"
  },
  {
    "name": "pcUseOfVehicle",
    "rule": {
      "required": false
    },
    "label": "Use of Vehicle"
  },
  {
    "name": "pcDeliveryReturn",
    "rule": {
      "required": false
    },
    "label": "Delivery/Return"
  },
  {
    "name": "pcPaymentCharge",
    "rule": {
      "required": false
    },
    "label": "Payment Charge"
  },  
  {
    "name": "pcRentalDamage",
    "rule": {
      "required": false
    },
    "label": "Rental Damage"
  },
  {
    "name": "pcInsuranceValidity",
    "rule": {
      "required": false
    },
    "label": "Insurance Validity"
  },
  {
    "name": "pcExclusion",
    "rule": {
      "required": false
    },
    "label": "Exclusion"
  }]

  export const POLICY_MAX_LENGTH = 50000;
export const BREAKDOWN_FIELD_MAX_LENGTH = 10000;

export const breakdownFieldRules = {
  validate: (value) =>
    !value || value.length <= BREAKDOWN_FIELD_MAX_LENGTH ||
    `Cannot exceed ${BREAKDOWN_FIELD_MAX_LENGTH.toLocaleString()} characters`,
};

export const locationPolicyRules = {
  validate: (value) =>
    !value || value.length <= POLICY_MAX_LENGTH ||
    `Policy cannot exceed ${POLICY_MAX_LENGTH.toLocaleString()} characters`,
};

export const editMode =
  [
    {
      name:"modTime",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod Time",
      type:"text"
    },
    {
      name:"modBy",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod By",
      type:"text"
    }
  ]